module.exports = __webpack_public_path__ + "img/vertical_3_2_8023.abe1d74c.png";